var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBlogTripTeaserBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 630.49 365.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19f59b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.61,57.52c31.21-.67,66.86,6,83.21,32.58,12.72,20.7,9.68,47.22,3.85,70.81s-14.08,47.56-10.41,71.57c4.45,29.14,26.19,56.66,18.66,85.16-5.42,20.54-25,34.43-45.14,41.25-47.23,16-100,1.84-143.28-22.95S360.61,276.47,320.36,247s-86.72-54.33-136.59-54.67C152.28,192.16,121.46,201.8,90,203S23.11,194.31,8.14,166.6C-1,149.61-.81,129.19,1,110,2.6,93,5.33,75.81,12.71,60.44,31.12,22.06,75.71,2,118.24.17s84.07,11.35,124.89,23.44c67.48,20,136.6,37.53,207,37.73C450.11,61.34,513.4,58,533.61,57.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.17,245.52c-.91,8.84-1,16.07,8.54,28.85,2.28,3,5.64,5.19,8.39,7.77a19.54,19.54,0,0,0,5.82,3.59c11.6,4.95,27,3.15,39-4.55a36.65,36.65,0,0,0,9-7.93,28.14,28.14,0,0,0,5.85-20.66,32.21,32.21,0,0,0-8.85-17.9c-11.19-11.95-30-17.05-48.32-13.1a24.91,24.91,0,0,0-8.32,3.08,22.28,22.28,0,0,0-5.4,5.07C7,234.55,5.17,245.52,5.17,245.52Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlogTripTeaserBig);
export default __webpack_public_path__ + "static/media/bg_blog_trip_teaser_big.cad2bcd95adf1abf9eb94c057e4d9a52.svg";
export { ForwardRef as ReactComponent };